import { render, staticRenderFns } from "./ruleItem.vue?vue&type=template&id=0197e057&scoped=true&"
import script from "./ruleItem.vue?vue&type=script&lang=js&"
export * from "./ruleItem.vue?vue&type=script&lang=js&"
import style0 from "./ruleItem.vue?vue&type=style&index=0&id=0197e057&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0197e057",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\workspace\\uat\\platform-uat\\Platform-foundation-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0197e057')) {
      api.createRecord('0197e057', component.options)
    } else {
      api.reload('0197e057', component.options)
    }
    module.hot.accept("./ruleItem.vue?vue&type=template&id=0197e057&scoped=true&", function () {
      api.rerender('0197e057', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/UserRule/ruleItem.vue"
export default component.exports